module.exports = __webpack_public_path__ + "static/2015-fineArt1-eaba3bdb2fb77b01e5920d55bfef0049.jpg";